import { css, Theme } from '@emotion/react'
import { helpers, fonts, typography } from '@/styles'

export const styles = (theme: Theme) => ({
  preview: {
    main: css`
      position: relative;

      width: 100%;
    `,

    button: {
      shared: css`
        ${helpers.resetDefaults};

        width: 100%;
        height: 28px;

        font-family: ${fonts.primary};
        font-size: ${typography.p};
        font-weight: bold;

        padding-bottom: 2px;

        transition: border 0.2s, color 0.2s;
        cursor: pointer;
      `,
      empty: css`
        border-bottom: 1px solid ${theme.colors.secondary.dark};
        color: ${theme.colors.secondary.darker};
      `,
      filled: css`
        border-bottom: 1px solid ${theme.colors.secondary.dark};
        color: ${theme.colors.secondary.normal};
      `,
      errored: css`
        border-bottom: 1px solid ${theme.colors.negative.normal};
        color: ${theme.colors.negative.normal};
      `,
      content: {
        main: css`
          display: flex;
        `,
        name: css`
          ${helpers.textOverflowEllipsis};

          margin-right: auto;
        `,
        icon: {
          shared: css`
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            width: 28px;
            height: 28px;

            & > svg {
              width: 14px;
              height: 14px;

              & > path {
                transition: fill 0.2s;
              }
            }
          `,
          empty: css`
            & > svg > path {
              color: ${theme.colors.accent.normal};
            }
          `,
          filled: css`
            & > svg > path {
              color: ${theme.colors.accent.normal};
            }
          `,
          errored: css`
            & > svg > path {
              color: ${theme.colors.negative.normal};
            }
          `,
        },
      },
    },

    error: {
      shared: css`
        display: flex;
        min-width: 0;

        transition: height 0.2s;
      `,
      visible: css`
        height: 24px;
      `,
      hidden: css`
        height: 0px;
      `,

      text: {
        shared: css`
          ${helpers.textOverflowEllipsis};

          font-size: ${typography.p};
          color: ${theme.colors.negative.normal};

          transition: opacity 0.4s;
          padding-left: 14px;
        `,
        visible: css`
          opacity: 1;
        `,
        hidden: css`
          opacity: 0;
        `,
      },
    },
  },
})
